var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCarrotIcon = function SvgCarrotIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_10605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.11999 9.91677L3.66791 8.47177M9.86583 10.6251L8.12333 8.8826M0.60791 15.3709C0.60791 15.3709 7.59916 12.8918 9.62499 10.8659C9.92126 10.5701 10.1564 10.2189 10.3169 9.83221C10.4774 9.44555 10.5602 9.03106 10.5605 8.6124C10.5608 8.19374 10.4787 7.77912 10.3188 7.39221C10.1589 7.00529 9.92434 6.65366 9.62854 6.3574C9.33273 6.06113 8.98147 5.82602 8.59481 5.66551C8.20815 5.50499 7.79365 5.4222 7.375 5.42188C6.95634 5.42155 6.54172 5.50368 6.1548 5.66359C5.76789 5.8235 5.41626 6.05805 5.11999 6.35385C3.08708 8.38677 0.60791 15.3709 0.60791 15.3709Z",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 6.37516C14.5833 6.37516 13.6413 4.9585 12.1042 4.9585C10.9425 4.9585 9.625 6.37516 9.625 6.37516C9.625 6.37516 10.5671 7.79183 12.1042 7.79183C13.6413 7.79183 14.5833 6.37516 14.5833 6.37516Z",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62516 1.4165C9.62516 1.4165 8.2085 2.35859 8.2085 3.89567C8.2085 5.43275 9.62516 6.37484 9.62516 6.37484C9.62516 6.37484 11.0418 5.0715 11.0418 3.89567C11.0418 2.35859 9.62516 1.4165 9.62516 1.4165Z",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_10605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarrotIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CarrotIcon.1318f465.svg";
export { ForwardRef as ReactComponent };